module.exports = __webpack_public_path__ + "static/img/04.3f5132bb.png";